import React from "react";
import Chart from "../../Chart";
import ExamplePieChart from "../../../../components/Chart/ExamplePieChart";

class PieChartExampleApplet extends Chart {

    render() {
        return <ExamplePieChart applet={this}
                          attributes={this.state.Attributes}
                          series={this.state.Series}
                          sx={this.state.sx}
                          enterpriseComponent={this.getEnterpriseComponent()} />;
    }

    state = {
        Name: "PieChartExampleApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        Attributes: {
            Height: 300,
            Margin: {right: 24},
        },
        Series: [
            {
                type: "pie",
                data: [],
                id: "pieId",
            }
        ]
    }
}

export default PieChartExampleApplet;
